import { render, staticRenderFns } from "./gptField.vue?vue&type=template&id=2c590b1c&scoped=true"
import script from "./gptField.vue?vue&type=script&lang=js"
export * from "./gptField.vue?vue&type=script&lang=js"
import style0 from "./gptField.vue?vue&type=style&index=0&id=2c590b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c590b1c",
  null
  
)

export default component.exports